const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';

/** Standard authenticated application chrome for navigation-oriented pages. */
export const Route = createFileRoute('/_authenticated/_app')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});